import { GetchErrorCode } from '@golden/getch';
import { map } from 'rxjs';
import GDKFormError from '../GDKFormError';
import GDKError from '../GDKError';
import { ErrorCode } from '../enums/ErrorCode';
import GDKValidationError from '../GDKValidationError';
export function catchGDKError(lang) {
    const throwGDKError = (error) => {
        switch (error.code) {
            case GetchErrorCode.STATUS_CODE:
                if (error.response?.data?.code) {
                    if (error.response?.data?.errors) {
                        return new GDKValidationError(error, lang, error.response?.data?.code, error.response?.data?.errors, error.response?.data);
                    }
                    if (error.response?.data?.code === ErrorCode.INPUT_INVALID && ((error.response?.data?.extra?.columns) != null)) {
                        return new GDKFormError(error, lang, error.response?.data?.code, error.response?.data?.extra?.columns, error.response?.data);
                    }
                    return new GDKError(error, lang, error.response?.data?.code, error.response?.data);
                }
                return new GDKError(error, lang, ErrorCode.SYSTEM_ERROR);
            case GetchErrorCode.TIMEOUT:
                return new GDKError(error, lang, ErrorCode.CLIENT_TIMEOUT);
            case GetchErrorCode.NETWORK_ERROR:
                return new GDKError(error, lang, ErrorCode.CLIENT_NETWORK_ERROR);
            default: // FAYTODO: test unexpect errorcode case, use some depreacated errorcode
                return new GDKError(error, lang, ErrorCode.ACTIVITY_CHRISTMAS_2022_LOCK);
        }
    };
    return (obs) => obs.pipe(map((error) => throwGDKError(error)));
}
//# sourceMappingURL=catchGDKError.js.map